module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image4_bg-ff024406516a147dc6d00b44a6a1025c.svg";